<script>
import vClickOutside from "v-click-outside";
import InputWebsiteVue from "../../components/shared/InputWebsite.vue";
import { DataService } from "../../config/dataService";
import localUser from "../../js/helpers/localUser";
import store from "../../vuex/store";
import ThreeDotsLoader from "../shared/ThreeDotsLoader.vue";
import ChatBotDemoMessage from "./ChatBotDemoMessage.vue";
import UserInfoForm from "./UserInfoForm.vue";
const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
const IMAGES_ENDPOINT = process.env.VUE_APP_IMAGES;

const CHAT_PREVIEW_PADDING = 35;
const CHAT_PREVIEW_WIDTH = 400;

export default {
  data() {
    return {
      isLoading: false,
      isOpen: false,
      inputMessage: "",
      messages: [],
      question: null,
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    InputWebsiteVue,
    ChatBotDemoMessage,
    ThreeDotsLoader,
    UserInfoForm,
  },
  name: "ChatBotDemo",
  props: {
    botSettings: {
      type: Object,
    },
    actions: {
      type: Array,
      default: () => [
        "Set-up Guidance",
        "Report a bug",
        "Feature request",
        "Latest release",
        "Feedback",
      ],
    },
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        gtag('event', 'chatbot_demo_widget_open', {});
        amplitude.getInstance().logEvent('chatbot_demo_widget_open', {});
      }
    },

    closeChat(e) {
      if (!this.isOpen || e.target.id === "btn") {
        return;
      }
      this.isOpen = false;
    },
    async sendMessage() {
      this.isLoading = true;

      this.question = { question: this.inputMessage, qCreatedAt: Date.now() };

      const outQuestion = {
        token: this.botSettings.token,
        widgetUserId: localUser.getLocalUser(this.botSettings.id) || null,
        ...this.question,
      };

      this.inputMessage = "";

      this.messages = [...this.messages, this.question];

      await DataService.post(
        `${API_ENDPOINT}widget/send-message`,
        outQuestion,
        { widgetid: this.botSettings.id }
      )
        .then(({ data }) => {
          if (
            data?.status &&
            data?.messages?.question &&
            data?.messages?.answer
          ) {
            if (data?.widgetUserId) {
              localUser.setLocalUser(this.botSettings?.id, data?.widgetUserId);
            }

            this.messages.pop();
            this.messages = [...this.messages, data?.messages];

            if (
              !this.chosenWidget?.owner?.subscription ||
              this.chosenWidget?.owner?.subscription?.status !== "active" ||
              this.chosenWidget?.owner?.subscription?.status !== "trialing"
            ) {
              store.dispatch(
                "setTotalMessagesCount",
                this.totalMessagesCount + 1
              );
            }
          } else {
            this.messages.pop();
            this.messages = [
              ...this.messages,
              {
                ...this.question,
                answer: "An error occurred :(",
                aCreatedAt: Date.now(),
                error: true,
              },
            ];
          }
        })
        .catch(({ response }) => {
          console.log(response);

          if (response?.status === 403) {
            this.messages.pop();
            return (this.messages = [
              ...this.messages,
              {
                ...this.question,
                answer:
                  "To be able to train and use the bot, purchase a subscription in the Billing section.",
                aCreatedAt: Date.now(),
                error: true,
              },
            ]);
          }
          if (response?.data?.errorDescription) {
            this.messages.pop();
            return (this.messages = [
              ...this.messages,
              {
                ...this.question,
                answer: response?.data?.errorDescription,
                aCreatedAt: Date.now(),
                error: true,
              },
            ]);
          } else {
            this.messages.pop();
            return (this.messages = [
              ...this.messages,
              {
                ...this.question,
                answer: "An error occurred :(",
                aCreatedAt: Date.now(),
                error: true,
              },
            ]);
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.question = null;
          this.focusInput();
        });
    },
    focusInput() {
      this.$refs.message.focus();
    },
  },
  computed: {
    chosenWidget() {
      return store?.state?.users?.chosenWidget;
    },
    chatHistory() {
      return store.state.users.chatHistory;
    },
    totalMessagesCount() {
      return store?.state?.users?.totalMessagesCount;
    },
    collectFormShown() {
      if (this.botSettings.userData === "none") {
        return false;
      } else {
        return !localUser.getLocalUser(this.botSettings.id);
      }
    },
    // historyLength() {
    //   const valuesArray = this.messages
    //     .map((message) => JSON.parse(JSON.stringify(message)))
    //     .map(({ question, answer }) => Object.values({ question, answer }));
    //   return valuesArray.flat().join(", ").split("").length;
    // },
    previewStyles() {
      return {
        padding: `${CHAT_PREVIEW_PADDING}px`,
        width: `${CHAT_PREVIEW_WIDTH + CHAT_PREVIEW_PADDING * 2}px`,
      };
    },

    chatbotBoxStyle() {
      return {
        height: `${this.botSettings.chatHight}px`,
        width: `${CHAT_PREVIEW_WIDTH}px`,
        fontSize: `${this.botSettings.fontSize}px`,
      };
    },

    horizontalPosition() {
      const position = this.botSettings.iconPosition;
      const horizontalDistance = this.botSettings.iconHorizontalDistance;

      return position === "BL"
        ? {
            left: `${horizontalDistance}px`,
          }
        : { right: `${horizontalDistance}px` };
    },

    botPosition() {
      const fromBottom =
        Number(this.botSettings.iconFromBottomDistance) +
        Number(this.botSettings.iconSize) +
        10;

      return {
        position: "fixed",
        bottom: `${fromBottom}px`,
        ...this.horizontalPosition,
      };
    },

    botIconPosition() {
      const fromBottom = this.botSettings.iconFromBottomDistance;
      const buttonIcon = this.botSettings.botIcon;

      return {
        position: "fixed",
        bottom: `${fromBottom}px`,
        ...this.horizontalPosition,
        background:
          buttonIcon && buttonIcon !== "null"
            ? "transparent"
            : this.botSettings.primaryColor,
      };
    },

    botIconBoxStyle() {
      const iconSize = this.botSettings.iconSize;

      return {
        height: iconSize ? `${iconSize}px` : "48px",
        width: iconSize ? `${iconSize}px` : "48px",
      };
    },

    thumbUpUrl() {
      return require("@/assets/icons/ThumbUp.svg");
    },

    sendUrl() {
      return require("@/assets/icons/sendIcon.svg");
    },

    botIcon() {
      const imagePreview = this.botSettings?.botIcon;
      return imagePreview && typeof imagePreview === "object"
        ? URL.createObjectURL(imagePreview)
        : imagePreview !== "null" && imagePreview?.length > 0
        ? IMAGES_ENDPOINT + imagePreview
        : require("@/assets/icons/ai-icon.svg");
    },

    agentIcon() {
      const imagePreview = this.botSettings?.agentIcon;

      return imagePreview && typeof imagePreview === "object"
        ? URL.createObjectURL(imagePreview)
        : imagePreview !== "null" && imagePreview?.length > 0
        ? IMAGES_ENDPOINT + imagePreview
        : null;
    },

    userIcon() {
      const imagePreview = this.botSettings?.userIcon;

      return imagePreview && typeof imagePreview === "object"
        ? URL.createObjectURL(imagePreview)
        : imagePreview !== "null" && imagePreview?.length > 0
        ? IMAGES_ENDPOINT + imagePreview
        : null;
    },

    hideFeedback() {
      const result = this.botSettings.hideFeedbackButton;
      return result;
    },

    hideToolTip() {
      const result = this.botSettings.hideToolTip;
      return result;
    },
  },
  watch: {
    messages: {
      handler() {
        const container = this.$el.querySelector("#messagesCard");
        this.$nextTick(() => {
          container.scrollTop = container.scrollHeight;
        });
      },
      deep: true,
    },
    chatHistory: {
      // deep: true,
      handler() {
        this.messages = this.chatHistory;
      },
    },
    // historyLength: {
    //   handler: function () {
    //     if (this.historyLength > 15000) {
    //       this.messages.shift();
    //     }
    //   },
    // },
  },
};
</script>

<template>
  <div>
    <div
      class="box"
      :class="{
        boxOpen: isOpen === true,
        left: botSettings.iconPosition === 'BL',
      }"
      :style="botPosition"
    >
      <div
        :class="{
          open: isOpen === true,
          left: botSettings.iconPosition === 'BL',
        }"
        class="chatbot_preview"
        :style="chatbotBoxStyle"
        v-click-outside="closeChat"
      >
        <UserInfoForm
          v-if="collectFormShown"
          :widget-id="botSettings.id"
          :data-types="botSettings.dataTypes"
          :user-data-collect="botSettings.userData"
          :primary-color="botSettings.primaryColor"
          :text-color="botSettings.textColor"
          :font-size="botSettings.fontSize"
        />
        <div
          class="chatbot_preview__heder"
          :style="{ background: botSettings.primaryColor }"
        >
          <div class="chatbot_preview__title-box">
            <div v-if="agentIcon" class="chatbot_preview__bot-icon-box">
              <img :src="agentIcon" alt="" />
            </div>
            <div>
              <p class="chatbot_preview__title">{{ this.botSettings.name }}</p>
              <p class="chatbot_preview__sub-title">Ai Assistant</p>
            </div>
          </div>
          <!-- <div v-if="!hideFeedback" class="chatbot_preview__thumbUp-box">
            <button class="chatbot_preview__thumbUp">
              <svg class="chatbot_preview__feedbackIcon">
                <use xlink:href="@/assets/icons/ThumbUp.svg#ThumbUp"></use>
              </svg>
            </button>
            <button
              class="chatbot_preview__thumbUp chatbot_preview__thumbUp--rotate180"
            >
              <svg class="chatbot_preview__feedbackIcon">
                <use xlink:href="@/assets/icons/ThumbUp.svg#ThumbUp"></use>
              </svg>
            </button>
          </div> -->
        </div>

        <div
          class="chatbot_preview__chat"
          :style="{ maxHeight: `${this.botSettings.chatHight - 150}px` }"
          id="messagesCard"
        >
          <div class="chatbot_preview__messages-box">
            <ul class="chatbot_preview__messages-list">
              <ChatBotDemoMessage
                :icons="{ agentIcon: agentIcon }"
                :v-if="botSettings.welcomeMessage"
                :message="{
                  answer: botSettings.welcomeMessage,
                  aCreatedAt: Date.now(),
                }"
                :textColor="botSettings.textColor"
                :bgColor="botSettings.primaryColor"
              />
              <ChatBotDemoMessage
                :icons="{ agentIcon: agentIcon, userIcon: userIcon }"
                v-for="(item, i) of messages"
                :key="i"
                :message="item"
                :textColor="botSettings.textColor"
                :bgColor="botSettings.primaryColor"
              />
              <ThreeDotsLoader
                v-if="isLoading"
                :bgColor="botSettings.primaryColor"
              />
            </ul>
          </div>

          <!-- <div v-if="!hideToolTip" class="chatbot_preview__action-box">
            <button
              v-for="action of actions"
              class="chatbot_preview__action"
              :style="{ color: botSettings.primaryColor, borderColor: botSettings.primaryColor }"
            >
              {{ action }}
            </button>
          </div> -->
        </div>

        <form @submit.prevent="sendMessage" class="chatbot_preview__footer">
          <div class="chatbot_preview__footer--content">
            <input
              ref="message"
              type="text"
              :placeholder="this.botSettings.placeholder"
              v-model="inputMessage"
              :style="{ color: botSettings.textColor }"
              maxlength="150"
              class="chatbot_preview__input"
            />
            <button
              type="submit"
              :disabled="inputMessage === ''"
              class="chatbot_preview__send-btn"
              :style="{ background: botSettings.primaryColor }"
            >
              <img :src="sendUrl" />
              <!-- <svg class="chatbot_preview__feedbackIcon">
                <use xlink:href="@/assets/icons/ThumbUp.svg#ThumbUp"></use>
              </svg> -->
            </button>
          </div>
          <div class="chatbot_preview__footer--powered">Powered by <span>ChatBot</span></div>
        </form>
      </div>
    </div>

    <button
      @click="toggleOpen"
      class="chatbot_preview__bot-icon-button"
      :style="botIconPosition"
    >
      <div :style="botIconBoxStyle">
        <img id="btn" :src="botIcon" alt="" />
      </div>
    </button>
  </div>
</template>

<style scoped lang="scss">
.box {
  position: relative;
  z-index: 10;
  width: auto;
  height: auto;
  transform: translate(50%, 50%) scale(0);
  transition: all 200ms linear;

  &.left {
    transform: translate(-50%, 50%) scale(0);
  }

  &.boxOpen {
    transform: translate(0, 0) scale(1);
  }

  @media (max-width: 475px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
}

.chatbot_preview__bot-icon-button {
  padding: 0;
  z-index: 100;
  font: inherit;
  color: inherit;
  background: transparent;
  cursor: pointer;
  text-align: center;
  border-radius: 50%;
  border: none;

  transition: all 150ms linear;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;

    & > img {
      width: 100%;
      height: 100%;
    }
  }

  &:hover {
    transform: scale(1.02);
  }
}

.chatbot_preview__title {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
  padding: 0;
}

.chatbot_preview__sub-title {
  font-family: inherit;
  color: #e0e0e0;
  font-size: 0.8em;
  font-weight: 400;
  line-height: 1.142;
  margin: 0;
  padding: 0;
}

.chatbot_preview {
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  object-fit: cover;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  transform: translate(50%, 50%) scale(0);
  transition: all 200ms linear;

  &.left {
    transform: translate(-50%, 50%) scale(0);
  }

  &.open {
    transform: translate(0, 0) scale(1);
  }

  @media (max-width: 475px) {
    position: absolute;
    bottom: 0;
    left: 5%;
    max-width: 90vw !important;
  }

  @media (max-height: 800px) {
    max-height: 70vh !important;
  }
}

.chatbot_preview__heder {
  padding: 20px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 1px 19px 0px rgba(0, 0, 0, 0.42);
  -webkit-box-shadow: 0px 1px 19px 0px rgba(0, 0, 0, 0.42);
  -moz-box-shadow: 0px 1px 19px 0px rgba(0, 0, 0, 0.42);
  z-index: 1;
}

.chatbot_preview__title-box {
  display: flex;
  align-items: center;
  gap: 20px;
}

.chatbot_preview__thumbUp-box {
  display: flex;
  gap: 25px;
}

.chatbot_preview__bot-icon-box {
  overflow: hidden;
  border-radius: 50%;
  position: relative;
  object-fit: cover;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  & > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.chatbot_preview__thumbUp {
  object-fit: cover;
  padding: 0;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  fill: #fff;

  & svg {
    width: 16px;
    height: 16px;
    fill: inherit;
  }

  &--rotate180 {
    & svg {
      transform: rotate(180deg);
    }
  }
}

.chatbot_preview__chat {
  padding: 10px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
}

.chatbot_preview__messages-box {
  flex-grow: 1;
}

.chatbot_preview__messages-list {
  /* width: 100%; */
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.chatbot_preview__action-box {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 24px;
}

.chatbot_preview__action {
  padding: 4px 8px;
  font: inherit;
  color: inherit;
  background-color: transparent;
  cursor: pointer;
  text-align: center;
  font-size: 0.78em;
  font-weight: 500;
  line-height: 1.71;
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  display: inline-block;
  transition: all ease-in-out 300ms;
}

.chatbot_preview__footer {
  width: 100%;
  border-top: 1px solid #e7e7e7;
  padding: 15px;
  flex-direction: column;
  box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.19);
  -webkit-box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.19);

  &--content {
        width: 100%;
        display: flex;
        justify-content: space-between;
  }

  &--powered {
      display: flex;
      justify-content: center;
      gap: 3px;
      padding: 10px 0px;
      color: #828282;
      font-size: 10px;
      font-weight: 700;

      span {
          color: #0165FF;
      }
  }
}

.chatbot_preview__send-btn {
  font: inherit;
  color: inherit;
  cursor: pointer;
  color: #fff;
  fill: #fff;
  text-align: center;
  border-radius: 6px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms linear;
  width: 52px;
  height: 52px;

  &:disabled {
    background-color: #969696 !important;
    pointer-events: none;
    cursor: default;
  }
}

.chatbot_preview__input {
  width: calc(100% - 52px - 15px);
  height: 52px;
  border-radius: 6px;
  border: 1px solid #e7e7e7;
  background: #f4f7ff;
  padding: 14px 20px;
}

.chatbot_preview__send-icon-box {
  object-fit: cover;
  width: 24px;
  height: 24px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: 100%;
    height: 100%;
  }
}
</style>
